import { Form, Select } from "antd";
import TimeIcon from "../_icons/TimeIcon";
import { QuestionTypeProps } from "../_types/type";

export default function TimeField({ index }: QuestionTypeProps) {
  return (
    <div className="mt-6 text-sm font-medium text-display-body">
      <Form.Item
        name={[index, "question_type_time"]}
        // valuePropName="checked"
        className="mb-0"
        initialValue={"HH:mm"}
      >
        <Select
          placeholder="Time"
          optionFilterProp="children"
          suffixIcon={<TimeIcon />}
          size="middle"
          options={[{ label: "HH:mm", value: "HH:mm" }]}
          className="select-border-none max-w-[500px] min-w-60 md:min-w-[500px]"
        />
      </Form.Item>
    </div>
  );
}
